import api from './api';

export type TipoEventoMissao =
  | 'pagamento' | 'topup' | 'sisp_payment' | 'compra_app'
  | 'ticket_purchase' | 'recarga' | 'referral' | 'login' | 'custom';

export type DificuldadeMissao = 'facil' | 'media' | 'dificil';

export interface Missao {
  id: number;
  titulo: string;
  descricao: string | null;
  icone: string;
  tipo_evento: TipoEventoMissao;
  objetivo: number;
  pontos_recompensa: number;
  bonus_cve: number;
  categoria: string;
  dificuldade: DificuldadeMissao;
  data_inicio: string | null;
  data_fim: string | null;
  max_completar_por_user: number;
  ativo: 0 | 1;
  ordem: number;
  created_at: string;
  total_participantes?: number;
  total_completaram?: number;
}

export interface MissaoStats {
  total: number;
  ativas: number;
  completadas_total: number;
  pontos_distribuidos: number;
}

export interface MissaoPayload {
  titulo: string;
  descricao?: string;
  icone?: string;
  tipo_evento: TipoEventoMissao;
  objetivo: number;
  pontos_recompensa: number;
  bonus_cve?: number;
  categoria?: string;
  dificuldade?: DificuldadeMissao;
  data_inicio?: string;
  data_fim?: string;
  max_completar_por_user?: number;
  ativo?: boolean;
  ordem?: number;
}

class MarketingMissoesService {
  async setup() { await api.post('/admin/marketing/missoes/setup'); }
  async stats(): Promise<MissaoStats> {
    const res = await api.get('/admin/marketing/missoes/stats');
    return res.data.data;
  }
  async list(): Promise<Missao[]> {
    const res = await api.get('/admin/marketing/missoes');
    return res.data.data || [];
  }
  async get(id: number): Promise<Missao> {
    const res = await api.get(`/admin/marketing/missoes/${id}`);
    return res.data.data;
  }
  async create(payload: MissaoPayload): Promise<Missao> {
    const res = await api.post('/admin/marketing/missoes', payload);
    return res.data.data;
  }
  async update(id: number, payload: Partial<MissaoPayload>) {
    await api.put(`/admin/marketing/missoes/${id}`, payload);
  }
  async toggle(id: number) {
    await api.post(`/admin/marketing/missoes/${id}/toggle`);
  }
  async remove(id: number) {
    await api.delete(`/admin/marketing/missoes/${id}`);
  }
}

export default new MarketingMissoesService();
